import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagicWand = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2,
		fill: "currentColor"
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M21.15,3.016c0.1,0.218 0.269,0.389 0.493,0.487l0.931,0.404c0.277,0.127 0.277,0.509 0,0.636l-0.924,0.404c-0.224,0.097 -0.401,0.269 -0.493,0.487l-0.731,1.661c-0.131,0.261 -0.524,0.261 -0.655,0l-0.731,-1.661c-0.1,-0.218 -0.269,-0.389 -0.493,-0.487l-0.924,-0.404c-0.277,-0.127 -0.277,-0.509 0,-0.636l0.924,-0.404c0.224,-0.097 0.401,-0.269 0.493,-0.487l0.731,-1.661c0.131,-0.261 0.524,-0.261 0.655,0l0.724,1.661Z",
				style: { fillRule: "nonzero" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.037,3.585c0.072,0.149 0.192,0.268 0.351,0.336l0.662,0.276c0.199,0.09 0.199,0.35 0,0.44l-0.662,0.276c-0.159,0.067 -0.287,0.187 -0.351,0.336l-0.518,1.142c-0.096,0.179 -0.375,0.179 -0.471,0l-0.518,-1.142c-0.072,-0.149 -0.192,-0.268 -0.351,-0.336l-0.662,-0.276c-0.199,-0.09 -0.199,-0.35 0,-0.44l0.662,-0.276c0.159,-0.067 0.287,-0.187 0.351,-0.336l0.518,-1.142c0.096,-0.179 0.375,-0.179 0.471,0l0.518,1.142Z",
				style: { fillRule: "nonzero" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.851,19.556l-1.275,1.247c-0.345,0.346 -0.345,0.899 0,1.246l0.315,0.315c0.337,0.346 0.896,0.346 1.233,-0.008l1.259,-1.263l-0.002,-0.002l10.734,-10.734l1.283,-1.278c0.333,-0.341 0.333,-0.951 0,-1.284l-0.253,-0.254c-0.34,-0.334 -1.03,-0.251 -1.414,0.133l-11.882,11.882Z",
				style: { fillRule: "nonzero" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.678,12.119c-0.156,-0.075 -0.279,-0.201 -0.353,-0.368l-0.525,-1.243c-0.098,-0.2 -0.377,-0.2 -0.468,0l-0.525,1.243c-0.066,0.159 -0.197,0.293 -0.353,0.368l-0.656,0.3c-0.197,0.1 -0.197,0.384 0,0.475l0.656,0.3c0.156,0.075 0.279,0.201 0.353,0.367l0.525,1.244c0.098,0.2 0.377,0.2 0.468,0l0.525,-1.244c0.066,-0.158 0.197,-0.292 0.353,-0.367l0.656,-0.3c0.197,-0.1 0.197,-0.384 0,-0.475l-0.656,-0.3Z",
				style: { fillRule: "nonzero" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.984,10.357c0.423,0 0.767,-0.343 0.767,-0.767c0,-0.423 -0.343,-0.767 -0.767,-0.767c-0.423,0 -0.767,0.343 -0.767,0.767c0,0.423 0.343,0.767 0.767,0.767Z",
				style: { fillRule: "nonzero" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.782,9.591c0,0.423 -0.343,0.767 -0.767,0.767c-0.423,0 -0.767,-0.343 -0.767,-0.767c0,-0.423 0.343,-0.767 0.767,-0.767c0.423,0 0.767,0.343 0.767,0.767Z",
				style: { fillRule: "nonzero" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.35,2.692c0.423,0 0.767,-0.343 0.767,-0.767c0,-0.423 -0.343,-0.767 -0.767,-0.767c-0.423,0 -0.767,0.343 -0.767,0.767c0,0.423 0.343,0.767 0.767,0.767Z",
				style: { fillRule: "nonzero" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.116,15.723c0,0.423 -0.343,0.767 -0.767,0.767c-0.423,0 -0.767,-0.343 -0.767,-0.767c0,-0.423 0.343,-0.767 0.767,-0.767c0.423,0 0.767,0.343 0.767,0.767Z",
				style: { fillRule: "nonzero" }
			})
		]
	})
});
export default SvgMagicWand;
